import type { FormControlLabelProps } from '@mui/material';
import { FormControlLabel as MuiFormControlLabel } from '@mui/material';

export const FormControlLabel = ({ sx, ...props }: FormControlLabelProps) => {
  const sxArray = Array.isArray(sx) ? sx : [sx];
  return (
    <MuiFormControlLabel
      sx={[{ m: 0 }, ...sxArray]}
      {...props}
    />
  );
};

export { type FormControlLabelProps } from '@mui/material';
